<app-spinner-overlay></app-spinner-overlay>

@if (data.titoloESRS) {
  <div
    style="
      font-family: Abel;
      font-size: 28px;
      color: var(--mat-color-accent);
      margin-top: 20px;
      margin-bottom: 10px;
    "
  >
    {{ titolo }}
  </div>
  <div class="titolo-elem-padre">
    <span style="font-size: 14px">{{ data.titoloESRS.etichetta }}</span>
    {{ data.titoloESRS.titolo }}
  </div>
} @else {
  <app-titolo-subtitolo [titolo]="titolo"></app-titolo-subtitolo>
}

<div mat-dialog-content class="dialog-center-cont">
  <form [formGroup]="formElementoIro">
    <div appFormContainer [larghezza]="3">
      <mat-form-field appFormElement [larghezza]="3" [riempi]="true">
        <mat-label>Descrizione</mat-label>
        <textarea
          matInput
          placeholder="Descrizione"
          formControlName="descrizione"
          rows="4"
        ></textarea>
        <mat-error appFormError></mat-error>
      </mat-form-field>

      <mat-form-field appFormElement [larghezza]="1" [riempi]="true">
        <mat-label>Fonte</mat-label>
        <input matInput placeholder="Fonte" formControlName="fonte" />
        <mat-error appFormError></mat-error>
      </mat-form-field>

      <mat-form-field class="input-form" appFormElement [larghezza]="1" [riempi]="true">
        <mat-label>Punto della catena del valore dove si genera</mat-label>
        <mat-select
          formControlName="catene"
          placeholder="Punto della catena del valore dove si genera"
          multiple
        >
          <mat-option *ngFor="let impt of arrayCatene" [value]="impt.codice">{{
            impt.descrizione
          }}</mat-option>
        </mat-select>
        <mat-error appFormError></mat-error>
      </mat-form-field>

      <mat-form-field class="input-form" appFormElement [larghezza]="1" [riempi]="true">
        <mat-label>Orizzonte temporale</mat-label>
        <mat-select formControlName="orizzontiTemporali" placeholder="Orizzonte temporale" multiple>
          <mat-option *ngFor="let impt of arrayOrizzontiTemporali" [value]="impt.codice">{{
            impt.descrizione
          }}</mat-option>
        </mat-select>
        <mat-error appFormError></mat-error>
      </mat-form-field>

      <!-- <mat-form-field appFormElement [larghezza]="3" [riempi]="true">
                <mat-label>Descrizione</mat-label>
                <input matInput placeholder="Descrizione" formControlName="descrizione" />
                <mat-error appFormError></mat-error>
            </mat-form-field> -->
    </div>
  </form>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="salva()" class="primary-button">Salva</button>
  </div>
</div>
